import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import ru from "./locales/ru.json";
import es from "./locales/es.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ru: { translation: ru },
      // v414.87 — Spanish covers the CUSTOMER surface (storefront + video
      // library); portal keys fall back to English automatically.
      es: { translation: es },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "ru", "es"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "reup-lang",
    },
  });

export default i18n;
